import React from 'react'
import task from "../../../Assets/images/task.png";
import task2 from "../../../Assets/images/task2.png";
import task3 from "../../../Assets/images/task3.png";

function No_Order() {
    return (
        <>
            <section className="aon-howit-area2 no-order-container">
                <div className="container">
                    <div className="aon-howit-area2-section">
                        <div className="aon-howit-area2-bg">
                            {/*Title Section Start*/}
                            <div className="section-head aon-title-center white">
                                <span className="aon-sub-title">
                                    NO ORDER YET !!
                                </span>
                                <h2 className="sf-title text-warning">
                                    How To Order
                                </h2>
                            </div>
                            {/*Title Section Start End*/}
                            <div className="section-content">
                                <div className="aon-categories-area2-section">
                                    <div className="row justify-content-center">
                                        {/* Block 1*/}
                                        <div className="col-lg-4 col-md-6">
                                            <div className="aon-howit-area2-iconbox aon-icon-effect">
                                                <div className="aone-howit-number">
                                                    01
                                                </div>
                                                <div className="aon-howit-area2-icon">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img
                                                                src={task}
                                                                alt=""
                                                            />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-howit-area2-content">
                                                    <h4 className="aon-tilte">
                                                        Find your Best company
                                                    </h4>
                                                    <p>
                                                        See company profiles
                                                        and then order.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Block 2*/}
                                        <div className="col-lg-4 col-md-6">
                                            <div className="aon-howit-area2-iconbox aon-howit-arrow aon-icon-effect">
                                                <div className="aone-howit-number">
                                                    02
                                                </div>
                                                <div className="aon-howit-area2-icon">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img
                                                                src={task2}
                                                                alt=""
                                                            />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-howit-area2-content">
                                                    <h4 className="aon-tilte">
                                                        Choose a Tasker
                                                    </h4>
                                                    <p>
                                                        This helps us
                                                        determine which
                                                        Taskers We are abest
                                                        jobs.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Block 3*/}
                                        <div className="col-lg-4 col-md-6">
                                            <div className="aon-howit-area2-iconbox aon-icon-effect">
                                                <div className="aone-howit-number">
                                                    03
                                                </div>
                                                <div className="aon-howit-area2-icon">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img
                                                                src={task3}
                                                                alt=""
                                                            />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-howit-area2-content">
                                                    <h4 className="aon-tilte">
                                                        Live Smarter
                                                    </h4>
                                                    <p>
                                                        This helps us
                                                        determine which
                                                        Taskers We are abest
                                                        jobs.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default No_Order